export const BusinessDataflowConfig = {
  getAll: '/dataflow/businessDataflows?asc={:isAsc}&pageNum={:pageNum}&orderHeader={:sortBy}&pageSize={:numberRows}'
};
